<template>
    <div class="d-flex">
        <CustomSelect class="mr-2" :disabled="disabled" :options="years" v-model.number="selectedYear" />
        <CustomSelect class="mr-2" :disabled="!selectedYear || disabled" :options="months(selectedYear)" v-model.number="selectedMonth" />
        <CustomSelect class="" :disabled="!selectedYear || !selectedMonth || disabled" :options="days(selectedYear, selectedMonth)" v-model.number="selectedDay" />
    </div>
</template>

<script>
import CustomSelect from './CustomSelect'

export default {
    name: 'ProgressiveDatePicker',
    components: {
        CustomSelect,
    },
    model: {
        prop: 'date',
        event: 'change',
    },
    props: {
        disabled: {
            type: Boolean,
            default() {
                return false
            }
        },
        valueAsString: {
            type: Boolean,
            default() {
                return false
            }
        },
        date: {
            type: [Object, String],
            default() {
                return this.valueAsString ? null : {
                    year: null,
                    month: null,
                    day: null,
                }
            }
        }
    },
    data() {
        return {
            monthNames: ['', 'January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'],
            years: [{label: 'Year', value: null}, ...Array.range((new Date).getFullYear(), 2000).map(v => { return {label: v, value: v}; })],
            selectedYear: null,
            selectedMonth: null,
            selectedDay: null,
        }
    },
    watch: {
        date: {
            handler(val) {
                if (val && typeof val == Object) {
                    this.selectedYear = val.year
                    this.selectedMonth = val.month
                    this.selectedDay = val.day
                } else if (val && typeof val == String) {
                    this.selectedYear = val.split('-')[0]
                    this.selectedMonth = val.split('-')[1]
                    this.selectedDay = val.split('-')[2]
                }
            },
            immediate: true,
        },
        selectedYear: {
            handler() {
                this.$emit('change', this.value)
            },
            immediate: false,
        },
        selectedMonth: {
            handler() {
                this.$emit('change', this.value)
            },
            immediate: false,
        },
        selectedDay: {
            handler() {
                this.$emit('change', this.value)
            },
            immediate: false,
        },
    },
    methods: {
        months() {
            const now = new Date
            const max = this.selectedYear == now.getFullYear() ? now.getMonth() + 1 : 12
            return [{label: 'Month', value: null}, ...Array.range(1, max).map(v => { return {label: this.monthNames[v], value: v}; })]
        },
        days(year, month) {
            if (!year || !month) {
                return []
            }
            const now = new Date
            let max = null
            if (this.selectedYear == now.getFullYear() && this.selectedMonth == now.getMonth() + 1) {
                max = now.getDate()
            } else {
                const days = [31, 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31]
                if (((year % 4 == 0) && (year % 100 != 0)) || (year % 400 == 0)) {
                    days[1] = 29
                }
                max = days[month - 1]
            }
            
            return [{label: 'Day', value: null}, ...Array.range(1, max).map(v => { return {label: v, value: v}; })]
        },
    },
    computed: {
        value() {
            if (this.valueAsString) {
                if (!this.selectedYear || !this.selectedMonth) {
                    return null
                }
                
                const pad = function(num,) {
                    num = num.toString();
                    while (num.length < 2) num = "0" + num;
                    return num;
                }
                
                let components = [
                    pad(this.selectedYear), 
                    pad(this.selectedMonth),
                    pad(this.selectedDay || 0),
                ]
                
                if (this.selectedDay) {
                    components.push()
                }
                return components.join('-')
            }
            return {
                year: this.selectedYear,
                month: this.selectedMonth,
                day: this.selectedDay,
            }
        }
    }
};
</script>

